import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getToken, login } from "helpers/Login";
import { Layout } from "components/Layout/Layout.styled";
import { Paragraph, Title } from "components/Text";
import { IAlertProps } from "components/Alert/Alert.interface";
import { IStore } from "constants/interfaces/store.interface";
import { AUTH_TYPES } from "store/actions/types";
import Alert from "components/Alert";
import { getUserInfo } from "helpers/Profile";

const Callback = () => {
  const [alert, setAlert] = useState<IAlertProps>({
    message: null,
    title: null,
    show: false,
    type: null,
    icon: null,
    onClose: () => {},
  });

  const dispatch = useDispatch();
  const appState = useSelector(
    (state: IStore) => state.persistedAuthReducer.uuid
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");

    if (appState === state) {
      getToken(code, state)
        .then((token_response) => {
          login(token_response.access_token)
            .then((login_response) => {
              getUserInfo(login_response.token).then((response) => {
                const { name, firstName, lastName, rut } = response;
                dispatch({
                  type: AUTH_TYPES.LOG_IN,
                  payload: {
                    user: {
                      name,
                      firstName,
                      lastName,
                      rut,
                    },
                    token: login_response.token,
                    isLoggedIn: true,
                  },
                });
              });
              setTimeout(() => {
                setAlert({
                  ...alert,
                  show: false,
                });
                window.location.href = `/`;
              }, 5000);
            })
            .catch((error) => {
              setAlert({
                show: true,
                message:
                  "Error al intentar obtener el token de acceso. Intentalo de nuevo en otro momento.",
                title: "Ups! Ha ocurrido un error.",
                icon: "cl-close",
                type: "danger",
              });
              console.error(error);
            });
        })
        .catch((error) => {
          setAlert({
            show: true,
            message:
              "Error al intentar obtener el token de acceso. Intentalo de nuevo en otro momento.",
            title: "Ups! Ha ocurrido un error.",
            icon: "cl-close",
            type: "danger",
          });
          console.error(error);
        });
    } else {
      setAlert({
        show: true,
        message:
          "Error al intentar obtener el token de acceso. Intentalo de nuevo en otro momento.",
        title: "Ups! Ha ocurrido un error.",
        icon: "cl-close",
        type: "danger",
      });
    }
  }, []);

  return (
    <Layout className="py-5">
      <div
        className="container justify-content-center align-content-center"
        style={{ height: "50vh" }}
      >
        <Alert {...alert} />
        <Title>Redirigiendo...</Title>
        <Paragraph>
          Por favor, espere mientras se redirige a la página.
        </Paragraph>
      </div>
    </Layout>
  );
};

export default Callback;
